<template>
  <aside class="d-flex flex-column">
    <search-box class="p-0 mb-4" placeholder="Search" :show-button-text="false" @search="handleSearch"></search-box>

    <div class="d-flex flex-column mb-4">
      <!-- Start of groups -->
      <div v-for="group in groups">
        <h5 class="mb-3 font-weight-bold font-size-large" v-text="group.title"></h5>
        <ul class="list-inline">
          <li v-for="item in group.items" class="list-item">
            <div class="single-item p-0">
              <div class="d-flex">
                <div class="item-image rounded">
                  <img
                    :src="baseImage(item)"
                    :class="{ 'image-placeholder': !hasBaseImage(item) }"
                    :alt="`${group.title} item's image`"
                  />
                </div>
                <div class="d-flex w-100">
                  <div class="d-flex flex-column w-100">
                    <h6 class="my-2" v-text="item.name"></h6>
                    <div><span class="text-muted" v-text="item.created_at"></span></div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </li>
        </ul>
      </div>
      <!-- /End of groups -->
    </div>
  </aside>
</template>

<script>
import SearchBox from '@core/components/SearchBox'

export default {
  name: 'BlogsAside',
  props: {
    groups: { type: Array, required: false, default: () => [] }
  },
  components: { SearchBox },
  methods: {
    handleSearch(target) {
      const { origin, pathname, search } = window.location
      const queryParams = new URLSearchParams(search)
      queryParams.set('search', target)

      // Reset pagination
      if (queryParams.has('page')) queryParams.set('page', 1)

      // Redirect to the new URL
      window.location.href = `${origin}${pathname}?${queryParams.toString()}`
    },
    hasBaseImage(item) {
      return item.base_image !== null && item.base_image !== ''
    },
    baseImage(item) {
      if (this.hasBaseImage(item)) return item.base_image

      return `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.single-item {
  position: relative;
  display: flex;
  padding: 6px 20px;
  flex-direction: column !important;
}

.item-image {
  margin-right: 0.4rem;
  overflow: hidden;

  img {
    height: 80px;
    width: 75px;
    min-width: 75px;
    object-fit: cover;
  }

  .image-placeholder {
    height: 80px;
    width: 75px;
    min-width: 75px;
  }
}
</style>
